<template>
  <div class="mt-3">
    <h2 class="fw-bold text-teal">Links Externos</h2>
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-3">
        <router-link to="/embeds/power-bi" title="Power BI">
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Power BI</h5>
              <i class="ph-chart-bar ph-2x text-teal" />
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Embeds',
}
</script>
